import { Link } from "react-router-dom";

export const ProductCard = ({ product }) => {
  const soldOut = product.status === "sold_out" || product.available === false;
  const img = product.images?.[0];
  return (
    <Link
      to={soldOut ? "#" : `/shop/${product.slug || product.handle}`}
      className="wc-product-card group block relative"
      data-testid={`product-card-${product.slug || product.handle}`}
      onClick={(e) => soldOut && e.preventDefault()}
    >
      <div className="relative overflow-hidden aspect-square bg-[#0a0a0a]">
        {img ? (
          <img
            src={img}
            alt={product.name}
            loading="lazy"
            className="wc-image wc-product-img w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center wc-label text-xs text-white/40">
            IMAGE COMING
          </div>
        )}
        {soldOut && (
          <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
            <span className="wc-label text-xs text-white border border-white px-4 py-2">
              SOLD OUT
            </span>
          </div>
        )}
        {product.badge === "core" && !soldOut && (
          <div className="absolute top-4 left-4 wc-label text-[10px] text-white bg-black/70 border border-white/40 px-2 py-1">
            ALWAYS AVAILABLE
          </div>
        )}
        {product.badge === "limited" && !soldOut && (
          <div className="absolute top-4 left-4 wc-label text-[10px] text-black bg-[#F5C518] px-2 py-1">
            DROP
          </div>
        )}

        {!soldOut && (
          <div className="wc-product-overlay absolute inset-0 bg-black/60 flex flex-col items-center justify-center gap-4 px-4">
            <div className="wc-heading text-white text-xl md:text-2xl text-center tracking-widest">
              {product.name}
            </div>
            <span
              className="wc-label text-[11px] text-black bg-white px-5 py-2"
              data-testid={`product-quick-add-${product.slug || product.handle}`}
            >
              View Product
            </span>
          </div>
        )}
      </div>

      <div className="pt-4 pb-2">
        <div className="wc-heading text-white text-xl md:text-2xl tracking-widest">
          {product.name}
        </div>
        <div className="text-sm text-white/70 mt-1">${product.price}</div>
      </div>
    </Link>
  );
};

export default ProductCard;
